import {
  Menu,
  Icon,
  Dropdown,
  Button,
  Responsive
} from "semantic-ui-react";

const CruiseActionsMenu = ({
  t,
  user,
  handleReservation,
  handleEdit,
  handlePassengers,
  handleIngala,
  handleGpsTax,
  handleOrderService,
  handleVoucher,
  handleFlights,
  handleGetPassengersTotal,
  setCruiseType,
  orderServiceState,
  passengersZarpeState
}) => {
  return (
    <>
      {/* ================= DESKTOP ================= */}
      <Responsive minWidth={992}>
        <Menu compact floated="right" stackable>
          <Menu.Item onClick={handleReservation}>
            <Icon name="calendar alternate" />
            {t("cruise_detail_reservations")}
          </Menu.Item>

          {user.role === "admin" && (
            <Menu.Item onClick={handleEdit}>
              <Icon name="pencil alternate" />
              {t("cruise_detail_edit")}
            </Menu.Item>
          )}

          <Menu.Item onClick={handlePassengers}>
            <Icon name="user" />
            {t("cruise_detail_passengers")}
          </Menu.Item>

          <Menu.Item onClick={handleIngala}>
            <Icon name="file alternate" />
            {t("cruise_detail_ingala")}
          </Menu.Item>

          <Menu.Item onClick={handleGpsTax}>
            <Icon name="file alternate" />
            {t("cruise_detail_gpstax")}
          </Menu.Item>

          <Menu.Item onClick={handleOrderService}>
            <Button
              className={
                orderServiceState.fetching
                  ? "loading order_button"
                  : "order_button"
              }
            >
              <Icon name="file alternate" />
              {t("cruise_detail_orderServices")}
            </Button>
          </Menu.Item>

          <Menu.Item onClick={handleVoucher}>
            <Icon name="file alternate" />
            {t("cruise_detail_voucher")}
          </Menu.Item>

          <Menu.Item onClick={handleFlights}>
            <Icon name="file alternate" />
            {t("cruise_detail_flights")}
          </Menu.Item>

          <Dropdown
            item
            text="Zarpe"
            loading={passengersZarpeState.fetching}
          >
            <Dropdown.Menu>
              <Dropdown.Item
                text="TO"
                onClick={() => {
                  handleGetPassengersTotal();
                  setCruiseType("TO");
                }}
              />
              <Dropdown.Item
                text="TO - PP"
                onClick={() => {
                  handleGetPassengersTotal();
                  setCruiseType("PP");
                }}
              />
              <Dropdown.Item
                text="TO - SP"
                onClick={() => {
                  handleGetPassengersTotal();
                  setCruiseType("SP");
                }}
              />
            </Dropdown.Menu>
          </Dropdown>
        </Menu>
      </Responsive>

      {/* ================= MOBILE ================= */}
      <Responsive maxWidth={991}>
        <div style={{ textAlign: "left" }}>
          <Dropdown
            text={t("Options menu")}
            icon="bars"
            floating
            labeled
            button
            className="icon primary"
          >
            <Dropdown.Menu>
              <Dropdown.Item
                icon="calendar alternate"
                text={t("cruise_detail_reservations")}
                onClick={handleReservation}
              />

              {user.role === "admin" && (
                <Dropdown.Item
                  icon="pencil alternate"
                  text={t("cruise_detail_edit")}
                  onClick={handleEdit}
                />
              )}

              <Dropdown.Item
                icon="user"
                text={t("cruise_detail_passengers")}
                onClick={handlePassengers}
              />

              <Dropdown.Item
                icon="file alternate"
                text={t("cruise_detail_ingala")}
                onClick={handleIngala}
              />

              <Dropdown.Item
                icon="file alternate"
                text={t("cruise_detail_gpstax")}
                onClick={handleGpsTax}
              />

              <Dropdown.Item
                icon="file alternate"
                text={t("cruise_detail_orderServices")}
                onClick={handleOrderService}
              />

              <Dropdown.Item
                icon="file alternate"
                text={t("cruise_detail_voucher")}
                onClick={handleVoucher}
              />

              <Dropdown.Item
                icon="file alternate"
                text={t("cruise_detail_flights")}
                onClick={handleFlights}
              />

              <Dropdown.Divider />

              <Dropdown.Header text="Zarpe" />

              <Dropdown.Item
                text="TO"
                onClick={() => {
                  handleGetPassengersTotal();
                  setCruiseType("TO");
                }}
              />
              <Dropdown.Item
                text="TO - PP"
                onClick={() => {
                  handleGetPassengersTotal();
                  setCruiseType("PP");
                }}
              />
              <Dropdown.Item
                text="TO - SP"
                onClick={() => {
                  handleGetPassengersTotal();
                  setCruiseType("SP");
                }}
              />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Responsive>
    </>
  );
};

export default CruiseActionsMenu;
